import { useMemo } from 'preact/hooks';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { useTranslation } from 'react-i18next';
import { ReasonsForReturn } from 'interfaces/WidgetConfigs.interface';

interface SelectOption {
  label: string;
  value: string;
}

const getReasonForReturnSelectOptions = (
  reasonForReturnConfig: ReasonsForReturn,
  translator,
): SelectOption[] => {
  const moveOtherOptionToBottom = (options: any[]): any[] => {
    const otherOptionIndex = options.findIndex(
      (option) => option.value === 'RETURN_REASON_OTHER',
    );

    if (otherOptionIndex === -1) {
      return options;
    }

    const newOptions = [...options];
    newOptions.push(newOptions.splice(otherOptionIndex, 1)[0]);

    return newOptions;
  };

  const standardOptions = reasonForReturnConfig.standard.map(({ value }) => ({
    label: translator(value),
    value,
  }));

  const customOptions = reasonForReturnConfig.custom
    .filter(({ isEnabled }) => isEnabled)
    .map(({ value, engDesc }) => ({
      label: value,
      value,
      engDesc,
    }));

  let options = [...standardOptions, ...customOptions];
  options = moveOtherOptionToBottom(options);

  return options;
};

export const useReasonForReturnInput = (): {
  selectOptions: SelectOption[];
} => {
  const { t } = useTranslation();
  const PTPConfig = usePTPConfigContext();
  const { reasonsForReturn } = PTPConfig.return;
  const selectOptions = useMemo(() => {
    return getReasonForReturnSelectOptions(reasonsForReturn, t);
  }, [reasonsForReturn]);

  return {
    selectOptions,
  };
};
